/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDiscountCodeFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPagedResultOfDiscountCodeFromDiscriminatorValue, serializeCreateCodeRequest, serializeDiscountCode, type CreateCodeRequest, type DiscountCode, type ErrorResponse, type InternalErrorResponse, type PagedResultOfDiscountCode } from '../../../../models/index.js';
// @ts-ignore
import { ExportRequestBuilderRequestsMetadata, type ExportRequestBuilder } from './exportEscaped/index.js';
// @ts-ignore
import { GenerateRequestBuilderRequestsMetadata, type GenerateRequestBuilder } from './generate/index.js';
// @ts-ignore
import { type WithDiscountCodeItemRequestBuilder, WithDiscountCodeItemRequestBuilderNavigationMetadata, WithDiscountCodeItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/campaigns/{campaignId}/codes
 */
export interface CodesRequestBuilder extends BaseRequestBuilder<CodesRequestBuilder> {
    /**
     * The export property
     */
    get exportEscaped(): ExportRequestBuilder;
    /**
     * The generate property
     */
    get generate(): GenerateRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.campaigns.item.codes.item collection
     * @param discountCodeId Unique identifier of the item
     * @returns {WithDiscountCodeItemRequestBuilder}
     */
     byDiscountCodeId(discountCodeId: string) : WithDiscountCodeItemRequestBuilder;
    /**
     * The campaign's codes, ordered by code, a page at a time, each with its own restrictions and its server-managed use count. A campaign with no codes is a success with an empty page.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfDiscountCode>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<CodesRequestBuilderGetQueryParameters> | undefined) : Promise<PagedResultOfDiscountCode | undefined>;
    /**
     * Adds one code to a code-triggered campaign. Codes are unique per organization, matched trimmed and case-insensitively, and can only narrow their campaign: their own use caps, per-customer cap, customer list and window are checked on top of the campaign's.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DiscountCode>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: CreateCodeRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DiscountCode | undefined>;
    /**
     * The campaign's codes, ordered by code, a page at a time, each with its own restrictions and its server-managed use count. A campaign with no codes is a success with an empty page.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<CodesRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * Adds one code to a code-triggered campaign. Codes are unique per organization, matched trimmed and case-insensitively, and can only narrow their campaign: their own use caps, per-customer cap, customer list and window are checked on top of the campaign's.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateCodeRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * The campaign's codes, ordered by code, a page at a time, each with its own restrictions and its server-managed use count. A campaign with no codes is a success with an empty page.
 */
export interface CodesRequestBuilderGetQueryParameters {
    pageNumber?: number;
    pageSize?: number;
}
/**
 * Uri template for the request builder.
 */
export const CodesRequestBuilderUriTemplate = "{+baseurl}/api/campaigns/{campaignId}/codes?pageNumber={pageNumber}&pageSize={pageSize}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CodesRequestBuilderNavigationMetadata: Record<Exclude<keyof CodesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byDiscountCodeId: {
        requestsMetadata: WithDiscountCodeItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithDiscountCodeItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["discountCodeId"],
    },
    exportEscaped: {
        requestsMetadata: ExportRequestBuilderRequestsMetadata,
    },
    generate: {
        requestsMetadata: GenerateRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CodesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CodesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfDiscountCodeFromDiscriminatorValue,
    },
    post: {
        uriTemplate: CodesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createDiscountCodeFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateCodeRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
